import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { InvestmentProgrammeDocumentDetailsRes } from '@dealstack/shared/lib/generated';
import { getDocumentWorkflowEventsQueryKey } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useDocumentWorkflowEvents';

export const useAssignSigner = (options: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}) => {
	const { dealId, programmeId, documentWorkflowInstanceId } = options;
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (body: { roleId: string; userId: string }) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_ASSIGN_POST,
				{
					dealId,
					programmeId,
					documentWorkflowInstanceId,
				}
			);

			const response = await makeRequest<
				ApiV1.Response<InvestmentProgrammeDocumentDetailsRes>
			>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});
			return response;
		},
		onSuccess: () => {
			return Promise.all([
				queryClient.invalidateQueries({
					queryKey: [
						formatUnicorn(
							API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_LIST_GET,
							{ dealId, programmeId, documentWorkflowInstanceId }
						),
					],
				}),
				queryClient.invalidateQueries({
					queryKey: [
						formatUnicorn(
							API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_GET,
							{ dealId, programmeId, documentWorkflowInstanceId }
						),
					],
				}),
				queryClient.invalidateQueries({
					queryKey: getDocumentWorkflowEventsQueryKey({
						programmeId,
						documentWorkflowInstanceId,
					}),
				}),
			]);
		},
	});
};
